import { Form } from "antd";
import RoleSelect from "./RoleSelect";
import React, { useEffect, useContext,useMemo } from 'react';
import { FormRoleSelectSettings } from './FormRoleSelectSettings';

import { Resizer,FormContext } from 'wsc-react-custom-form';

const defaultProps = {
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  fillSpace: 'no',
  padding: ['0', '0', '0', '0'],
  margin: ['0', '0', '0', '0'],
  background: { r: 255, g: 255, b: 255, a: 1 },
  color: { r: 0, g: 0, b: 0, a: 1 },
  shadow: 0,
  radius: 0,
  width: '100%',
  height: 'auto',
};

export const FormRoleSelect = (props) => {
  props = {
    ...defaultProps,
    ...props,
  };
  const {
    flexDirection,
    alignItems,
    justifyContent,
    fillSpace,
    background,
    color,
    padding,
    margin,
    shadow,
    radius,
    label,
    labelSpan,
    labelOffset,
    wrapperSpan,
    wrapperOffset,
    showLabel,
    name,
    rules,
  } = props;

  const { form, formdata } = useContext(FormContext);

  // name使用点号分割的：转换为数组
  const nameArray = useMemo(()=>{
    const names = name.split('.');
    if (names.length === 1) {
      return names[0];
    } else {
      return names;
    }
  }, [name]);
  // 获取级联属性
  useEffect(()=> {
    if (Array.isArray(nameArray)) {
      const value = nameArray.reduce((acc, item) => {
        if (acc?.hasOwnProperty(item)) {
          return acc[item];
        }
        return undefined;
      }, formdata);
      form.setFieldValue(nameArray, value);
    } else {
      form.setFieldValue(nameArray, formdata[name]);
    }
  }, [form, formdata, nameArray]);

  let noLabel = (showLabel == "false");
  return (<Resizer
    propKey={{ width: 'width', height: 'height' }}
    style={{
      justifyContent,
      flexDirection,
      alignItems,
      background: `rgba(${background.r}, ${background.g}, ${background.b}, ${background.a})})`,
      color: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
      padding: `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`,
      margin: `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`,
      boxShadow:
        shadow === 0
          ? 'none'
          : `0px 3px 100px ${shadow}px rgba(0, 0, 0, 0.13)`,
      borderRadius: `${radius}px`,
      flex: fillSpace === 'yes' ? 1 : 'unset',
    }}
  ><Form.Item 
    style={{ width: "100%" }}
    label={noLabel?null:label}
    labelCol={{span: labelSpan, offset: labelOffset}}
    wrapperCol={{span: wrapperSpan, offset: wrapperOffset}}
    name={nameArray}
    //initialValue={formdata[name]}
    rules={rules}
  >
     <RoleSelect />
    </Form.Item></Resizer>);
};


FormRoleSelect.craft = {
  displayName: 'FormRoleSelect',
  props: {
    name: "Ent1",
    label: "选择角色",
    labelSpan: 6,
    labelOffset: 0,
    wrapperSpan: 18,
    wrapperOffset: 0,
    showLabel: "true",
    rules: [{ required: true, message: "角色必须选择！" }],
    ...defaultProps
  },
  related: {
    toolbar: FormRoleSelectSettings,
  },
};

//FormRoleSelect.name = "FormRoleSelect";

FormRoleSelect.Icon = () => {
  return (<span>FormRoleSelect</span>);
}